import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "divide-y" }
const _hoisted_2 = { class: "w-1/3 pr-10" }
const _hoisted_3 = { class: "text-lg leading-6 font-medium" }
const _hoisted_4 = { class: "text-sm leading-5 font-normal text-gray-500 mt-1" }
const _hoisted_5 = { class: "w-2/3 pl-10" }
const _hoisted_6 = { class: "flex flex-wrap" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center -mt-1.5"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 1 }

import store from "@/store"
  import { ref, toRefs } from 'vue'
  import { useModals } from "@/composables"
  import { Actions } from "@/store/enums/StoreEnums"

  import { marked } from "marked"
  import * as DOMPurify from "dompurify"

  import { MailIcon, PhoneIcon } from "@heroicons/vue/solid"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  props: {
    originator: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  setup(__props) {

  const { showNotification } = useModals()

  const props = __props
  const { originator } = toRefs(props)

  const categories = ref<any>({
    fullName: {
      title: 'Full name',
      model: 'name'
    },
    email: {
      title: 'Email',
      model: 'email'
    },
    phone: {
      title: 'Phone number',
      model: 'phone'
    },
    description: {
      title: 'Description & Notes',
      model: 'description'
    },
    actions: {
      title: 'Quick actions',
      subtitle: '',
      model: 'actions'
    }
  })

  const updateDeletedStatus = async (deleted: boolean) => {
    const fields = [
      'id', 'rating', 'creditBoxes',
      'lenderId', 'name', 'phone',
      'email', 'description', 'preferredCommunicationType',
      'isVerified', 'userAccountId'
    ]

    const payload: any = {}

    fields.forEach(field => {
      payload[field] = originator.value[field]
    })

    payload.deleted = deleted

    try {
      const response = await store.dispatch(Actions.UPDATE_ORIGINATOR, payload)
      if (response.deleted) {
        showNotification(`${response.name} was soft deleted`)
      } else {
        showNotification(`${response.name} was restored`)
      }
    } catch (error: any) {
      console.log(error)
      showNotification(error?.response?.data?.errors || error.message || 'Something went wrong', 'error')
    }
  }

  const parseMarkdown = (value: string) => {
    return DOMPurify.sanitize(marked.parse(value))
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, ({ title, subtitle, model }, category) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "flex p-6",
        key: category
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(title), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(subtitle), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (model == 'actions')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (!_unref(originator).deleted)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "border rounded-md text-sm px-3 py-1.5 mr-2 flex items-center",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (updateDeletedStatus(true)))
                      }, " Soft delete "))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "border rounded-md text-sm px-3 py-1.5 mr-2 flex items-center",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (updateDeletedStatus(false)))
                      }, " Restore originator "))
                ]))
              : (['name', 'email', 'phone'].includes(model))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (model == 'name')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(originator)[model] || '–'), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_9, [
                          (!_unref(originator)[model])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "–"))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: `${model == 'email' ? 'mailto:' : 'tel:'}${_unref(originator)[model]}`,
                                class: "text-sky flex items-center"
                              }, [
                                (model == 'email')
                                  ? (_openBlock(), _createBlock(_unref(MailIcon), {
                                      key: 0,
                                      class: "w-4 h-4 text-gray-500 mr-2"
                                    }))
                                  : (_openBlock(), _createBlock(_unref(PhoneIcon), {
                                      key: 1,
                                      class: "w-4 h-4 text-gray-500 mr-2"
                                    })),
                                _createTextVNode(" " + _toDisplayString(_unref(originator)[model]), 1)
                              ], 8, _hoisted_11))
                        ]))
                  ], 64))
                : (model == 'description')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_unref(originator)[model])
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            innerHTML: parseMarkdown(_unref(originator)[model]),
                            class: "w-full markdown-box"
                          }, null, 8, _hoisted_12))
                        : (_openBlock(), _createElementBlock("p", _hoisted_13, "–"))
                    ], 64))
                  : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})